import React from "react";

// Inline geometric LE monogram with neon cyan accent line
export function Logo({ size = 36, withWordmark = true, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Labour Engine"
      >
        {/* outer frame */}
        <rect x="1" y="1" width="46" height="46" rx="2" stroke="#00E5FF" strokeOpacity="0.35" strokeWidth="1" />
        {/* L */}
        <path
          d="M10 10 L10 36 L22 36"
          stroke="#FFFFFF"
          strokeWidth="3"
          strokeLinecap="square"
          fill="none"
        />
        {/* E */}
        <path
          d="M28 10 L40 10 M28 10 L28 36 L40 36 M28 23 L37 23"
          stroke="#FFFFFF"
          strokeWidth="3"
          strokeLinecap="square"
          fill="none"
        />
        {/* neon accent */}
        <path d="M10 36 L40 36" stroke="#00E5FF" strokeWidth="2" />
        <circle cx="10" cy="36" r="2" fill="#00E5FF" />
        <circle cx="40" cy="36" r="2" fill="#00E5FF" />
      </svg>
      {withWordmark && (
        <div className="flex flex-col leading-none">
          <span
            className="text-white font-bold tracking-tight"
            style={{ fontFamily: "'Outfit', sans-serif", fontSize: 16, letterSpacing: "-0.01em" }}
          >
            Labour Engine
          </span>
          <span
            className="text-[10px] uppercase tracking-[0.25em] mt-1 text-[#9BA1A6]"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Automation
          </span>
        </div>
      )}
    </div>
  );
}
